import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { BaseBus } from "./BaseBus";
export class BidsheetSummaryBus extends BaseBus{

    constructor(busObj: BidsheetSummaryBus) {
        super(busObj);

    }
    CID(): any {
        return this.bidsheetSummaryId ;
    }
    setId(id: any) {
        this.bidsheetSummaryId  = id;
    }
    setParentId(id: any) {
        this.bidSheetDetailId = id;
    }
    initialize(data: BidsheetSummaryBus) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: BidsheetSummaryBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);

    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        this.updateDt = date;
        if (this.hasId) {
            this.updateUserId = userId;

        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
             this.updateUserId = userId;
        }
    }

   bidsheetSummaryId  :string;
    summaryId :string
    bidSheetDetailId : string;
    description  : string;
    cost : number;
    sell: number;
    margin :number;
    sequence : number;
    salesTax:number;
    insertDt: Date;
    updateDt: Date;
    updateUserId: string;
    insertUserId: string;
}